export const hotelCollabs = [
  {
    id: "bambootel-bali",
    name: "Bambootel Bali",
    location: "Bali, Indonesia",
    creator: "The Vogue Vanity (Daizy & Ankit)",
    creatorLink: "https://www.instagram.com/the.vogue.vanity/",
    description: "An immersive escape into sustainable luxury, showcasing the unique bamboo architecture and emerald landscapes of Bali.",
    status: "Live",
    image: "/Bambootel_Bali_HD_Photos/img_3.jpg",
    // ADD YOUR GOOGLE DRIVE DIRECT LINKS HERE
    heroImages: [
      "/Bambootel_Bali_HD_Photos/img_1.jpg",
      "/Bambootel_Bali_HD_Photos/img_3.jpg",
      "/Bambootel_Bali_HD_Photos/img_4.jpg"
    ],
    //timeline: "28 - 31 March 2026",
    stories: "https://www.instagram.com/stories/highlights/18100697518753811/",
    post: "https://www.instagram.com/p/DWq2yEsEok9/?img_index=1",
    reel: "https://www.instagram.com/p/DWvdFKokpBn/",
    website: "https://www.bambootel.com/"
  },
  {
    id: "saba-villas-bali",
    name: "Saba Villas Bali",
    location: "Bali, Indonesia",
    creator: "Shreyasi Sarkar",
    creatorLink: "https://www.instagram.com/shreyasi.s/",
    description: "A masterclass in private sanctuary living, focusing on minimalist design and high-end Balinese hospitality.",
    status: "Live",
    image: "https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7",
    heroImages: [
      "/Saba_Villas_Bali/img_1.jpg",
      "/Saba_Villas_Bali/img_2.jpg",
      "/Saba_Villas_Bali/img_3.jpg",
      "/Saba_Villas_Bali/img_4.jpg"
    ],
    //timeline: "08 - 11 March 2026",
    stories: "https://www.instagram.com/stories/highlights/18316900912283129/",
    post: "https://www.instagram.com/p/DWuFMuJEk8Z/?img_index=1",
    reel: "https://www.instagram.com/reel/DXCrDPLiIsG/?igsh=MTJ4aHlvM2ltNjVhZA==",
    website: "https://sabavillasbali.com/"
  },
  {
    id: "aloft-bangkok",
    name: "Aloft Bangkok Sukhumvit 11",
    location: "Bangkok, Thailand",
    creator: "Saili Satwe (thenattybrowngirl)",
    creatorLink: "https://www.instagram.com/thenattybrowngirl/",
    description: "Capturing the energetic pulse of Bangkok through a stay that blends urban vibrant nightlife with tech-forward luxury.",
    status: "Live",
    image: "/Aloft_Bangkok_HD_Photos/img1.jpg",
    heroImages: [
      "/Aloft_Bangkok_HD_Photos/img2.jpg",
      "/Aloft_Bangkok_HD_Photos/img3.jpg",
      "/Aloft_Bangkok_HD_Photos/img4.jpg"
    ],
    //timeline: "20 - 22 Feb 2026",
    stories: "https://www.instagram.com/s/aGlnaGxpZ2h0OjE4MjIzODQ1NzA2MzEzMTEz?story_media_id=3861427958271490602",
    post: "https://www.instagram.com/p/DWJlDYPkttE/",
    reel: "https://www.instagram.com/reel/DWT6L2dEmWY/",
    website: "https://www.marriott.com/en-us/hotels/bkkal-aloft-bangkok-sukhumvit-11/overview/"
  },
  {
    id: "modena-by-fraser",
    name: "Modena by Fraser Bangkok",
    location: "Bangkok, Thailand",
    creator: "Saili Satwe (thenattybrowngirl)",
    creatorLink: "https://www.instagram.com/thenattybrowngirl/",
    description: "Boutique residential collaboration highlighting a balanced lifestyle for the modern global traveler.",
    status: "Live",
    image: "/Modena_Bangkok_HD_Photos/img2.jpg",
    heroImages: [
      "/Modena_Bangkok_HD_Photos/img1.jpg",
      "/Modena_Bangkok_HD_Photos/img3.jpg",
      "/Modena_Bangkok_HD_Photos/img4.jpg"
    ],
    //timeline: "17 - 20 Feb 2026",
    stories: "https://www.instagram.com/s/aGlnaGxpZ2h0OjE3OTk5NDk3MjQ0ODg3NzAy?story_media_id=3835164337375866045",
    post: "https://www.instagram.com/p/DVJKHJcDM8f/",
    reel: "https://www.instagram.com/reel/DWEe0u5DMlW/",
    website: "https://www.frasershospitality.com/en/thailand/bangkok/modena-by-fraser-bangkok/"
  },
  {
    id: "azul-beach-club",
    name: "Azul Beach Club Bali",
    location: "Bali, Indonesia",
    creator: "Shreyasi Sarkar",
    creatorLink: "https://www.instagram.com/shreyasi.s/",
    description: "Visual-led dining campaign for Bali's premier tiki-themed beach club and seaside experience.",
    status: "Live",
    image: "/Azul_Beach_Club_HD_Photos/img4.jpg",
    heroImages: [
      "/Azul_Beach_Club_HD_Photos/img1.jpg",
      "/Azul_Beach_Club_HD_Photos/img2.jpg",
      "/Azul_Beach_Club_HD_Photos/img3.jpg",
      
    ],
    //timeline: "March 2026",
    stories: "https://www.instagram.com/stories/highlights/18306638599275175/",
    post: "https://www.instagram.com/p/DV-claBkYxc/",
    reel: null,
    website: "https://www.instagram.com/azulbeachclub"
  }
];